import {Injector} from "@angular/core";

/**
 *
 * @class ServiceLocator
 *
 * We need a simple/reliable way to get to the Angular Injector class, from anywhere in
 * our application, so that we can dynamically inject services where we need them.  We
 * follow the solution suggested here:
 *
 * https://stackoverflow.com/questions/41432388/how-to-inject-service-into-class-not-component
 *
 * of just using a static singleton to get to the Injector.  The injector is assigned by
 * the Angular AppModule class, so we know it will be setup by the time we need ot use it.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2022
 *
 */

export class ServiceLocator {

  static injector: Injector;

}
